import React from "react";
import { Card, Col } from "react-bootstrap";

const SingleTeacher = (props) => {
  const{name,img,title}=props.data
  return (
    <>
      <Col md="6" sm="12" lg="4" className="mb-5">
        <Card>
          <Card.Body className="text-center rounded">
            <img src={img} alt="" className="img-fluid rounded pb-3" />
            <Card.Title className="single-teacher-name" style={{color:"#17543E", fontSize:"35px",fontWeight:'600'}}>
             {name}
            </Card.Title>
            <Card.Subtitle className="mb-2 text-muted single-teacher-title ">
             {title}
            </Card.Subtitle>
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};

export default SingleTeacher;
